import { ColumnDef } from '@tanstack/react-table';
import dayjs from 'dayjs';
import { capitalize } from '../../../../../../../../../utils';
import { dateFormat } from '../../../../../../../../../contstant';

export interface ScanTimeRes {
  scanTime: string;
  uspsCodeDesc: string;
  facility: string;
}

export const scanTimeCol: ColumnDef<ScanTimeRes>[] = [
  {
    accessorKey: 'scanTime',
    header: 'Scan Time',
    cell: ({ row }) => dayjs(row.getValue('scanTime')).format(dateFormat),
  },
  {
    accessorKey: 'uspsCodeDesc',
    header: 'USPS Operation Code Description',
    cell: ({ row }) => capitalize(row.original.uspsCodeDesc),
  },
  {
    accessorKey: 'facility',
    header: 'USPS facility',
    cell: ({ row }) => capitalize(row.original.facility),
  },
];
